import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import "./CityStreetSelector.css";
import LogosAndMessages from './LogosAndMessages';
import Select from 'react-select';
import _ from 'lodash';
import Levenshtein from 'fast-levenshtein';




const CityStreetSelector = (props) => {
  const {
    selectedYear,
    handleYearChange,
    setCollectionTypes,
    setCollectionDates,
    selectedType,
    setSelectedType,
    collectionTypes
  } = props;

  const [input, setInput] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [streets, setStreets] = useState([]);
  const [selectedStreet, setSelectedStreet] = useState("");


  const [logos, setLogos] = useState([]);
  const [messages, setMessages] = useState([]);

  const [step, setStep] = useState(0);
  const nextStep = () => setStep(step + 1);

  const [noOptionsMessage, setNoOptionsMessage] = useState('Saisissez les premières lettres de votre ville');
  const [noStreetOptionsMessage, setNoStreetOptionsMessage] = useState('Saisissez les premières lettres de votre rue');

  const [hasStreets, setHasStreets] = useState(false); // Nouvel état pour vérifier si la ville a des rues ou non

  useEffect(() => {
    setSelectedStreet("");
    setStreets([]);
  }, [input, selectedCity]);

  useEffect(() => {
    if (input.length > 1) {
      axios.get(`http://51.38.239.111:5000/cities?input=${input}`).then((response) => {
        setCities(response.data.commune);
      });
    } else {
      setCities([]);
    }
  }, [input]);

  useEffect(() => {
    if (selectedCity) {
      axios.get(`http://51.38.239.111:5000/rues?city=${selectedCity}`).then((response) => {
        setStreets(response.data.adresse);
        setHasStreets(response.data.adresse.length > 0); // Mettre à jour 'hasStreets'
      });
    }
  }, [selectedCity]);

  useEffect(() => {
    if (input.length < 2) {
      setNoOptionsMessage('Saisissez les premières lettres de votre ville');
    } else {
      setNoOptionsMessage('Aucune option');
    }
  }, [input]);

  useEffect(() => {
    if (!selectedStreet || selectedStreet.length < 2) {
      setNoStreetOptionsMessage('Saisissez les premières lettres de votre rue');
    } else {
      setNoStreetOptionsMessage('Aucune option');
    }
  }, [selectedStreet]);

  const handleClick = async () => {
    const apiSelectedStreet = selectedStreet === "" ? "vide" : encodeURIComponent(selectedStreet);

    // console.log(`http://51.38.239.111:5000/api/get_dates?city=${selectedCity}&street=${apiSelectedStreet}&year=${selectedYear}`)
    const response = await axios.get(
      `http://51.38.239.111:5000/api/get_dates?city=${selectedCity}&street=${apiSelectedStreet}&year=${selectedYear}`
    );
    const dates = response.data.dates;
    setCollectionDates(dates);

    const uniqueTypes = [];
    const seenTypes = {};

    dates.forEach((date) => {
      if (!seenTypes[date.type]) {
        seenTypes[date.type] = true;
        uniqueTypes.push({ type: date.type, type1: date.type1 });
      }
    });

    setCollectionTypes(uniqueTypes);


    // Récupération des logos et messages
    // console.log(`http://localhost:5000/logos_and_messages?commune=${selectedCity}&adresse=${apiSelectedStreet}`)
    const responseLogosAndMessages = await fetch(`http://51.38.239.111:5000/logos_and_messages?commune=${selectedCity}&adresse=${apiSelectedStreet}`);
    const dataLogosAndMessages = await responseLogosAndMessages.json();
    console.log(dataLogosAndMessages)
    setLogos(dataLogosAndMessages.logos);
    setMessages(dataLogosAndMessages.messages);
  };



  const cityOptions = cities.map(city => ({
    value: `${city.libelle} [${city.insee}]`,
    label: `${city.libelle} [${city.insee}]`
  }));

  cityOptions.sort((a, b) => {
    const distanceA = Levenshtein.get(input, a.label);
    const distanceB = Levenshtein.get(input, b.label);

    return distanceA - distanceB;
  });

  const streetOptions = streets.map((street, index) => ({
    value: street[0],
    label: street[0]
  }));

  streetOptions.sort((a, b) => {
    const distanceA = Levenshtein.get(selectedCity, a.label);  // Remplacez 'selectedCity' par votre entrée de rue
    const distanceB = Levenshtein.get(selectedCity, b.label);  // Remplacez 'selectedCity' par votre entrée de rue

    return distanceA - distanceB;
  });

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption.value);
    setSelectedStreet("");
    setStreets([]);
    setHasStreets(false);
  };

  const handleStreetChange = (selectedOption) => {
    setSelectedStreet(selectedOption.value);
  };

  const debouncedSave = useCallback(
    _.debounce((newValue) => {
      if (newValue.length > 2) {
        axios.get(`http://51.38.239.111:5000/cities?input=${newValue}`).then((response) => {
          setCities(response.data.commune);
        });
      } else {
        setCities([]);
      }
    }, 500),
    [] // sera recréé à chaque fois que la valeur d'entrée change
  );

  useEffect(() => {
    debouncedSave(input);
  }, [input, debouncedSave]);


  return (
    <>
      <LogosAndMessages logos={logos} messages={messages} />

      <div className="city-street-selector">
        {/* <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Recherchez votre ville"
          className="city-input"
        />
        <select
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.target.value)}
          className="city-select"
        >
          <option value="">Sélectionnez votre ville</option>
          {cities.map((city) => (
            <option key={city.city_id} value={`${city.libelle} [${city.insee}]`}>
              {city.libelle} [{city.insee}]
            </option>
          ))}
        </select> */}
        <Select
          value={cityOptions.find(option => option.value === selectedCity)}
          onChange={handleCityChange}
          onInputChange={setInput}
          options={cityOptions}
          className="city-select"
          placeholder="Sélectionnez votre ville"
          noOptionsMessage={() => noOptionsMessage}
        />
        {/* <select
          value={selectedStreet}
          onChange={(e) => setSelectedStreet(e.target.value)}
          className="street-select"
        >
          <option value="">Sélectionnez votre rue</option>
          {streets.map((street, index) => (
            <option key={index} value={street[0]}>
              {street[0]}
            </option>
          ))}
        </select> */}

        {hasStreets && (
          <Select
            key={selectedCity}
            value={streetOptions.find(option => option.value === selectedStreet)}
            onChange={handleStreetChange}
            options={streetOptions}
            className="street-select"
            placeholder="Sélectionnez votre rue"
            noOptionsMessage={() => noStreetOptionsMessage}
          />
        )}


        {collectionTypes.length > 0 && (
          <select
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            className="type-select"
          >
            <option value="toustypes">Tous les types</option>
            {collectionTypes.map((typeObj, index) => (
              <option key={index} value={typeObj.type}>
                {typeObj.type1}
              </option>
            ))}
          </select>
        )}

        <div className="year-select-container">
          <label htmlFor="year-select">Année: </label>
          <select
            id="year-select"
            value={selectedYear}
            onChange={handleYearChange}
          >
            {Array.from({ length: 10 }, (_, index) => (
              <option key={index} value={selectedYear - 5 + index}>
                {selectedYear - 5 + index}
              </option>
            ))}
          </select>
        </div>
        <button onClick={handleClick} className="fetch-dates-button">
          Valider
        </button>
      </div>
    </>
  );
};

export default CityStreetSelector;
